import React from 'react';
import { StyledContainer } from '../../../components/container/styles';
import { Col, Row, Spin } from 'antd';
import { CardTheme } from '../../../components/card';
import { TextLarge } from '../../../components/text';
import { ButtonTheme, RenderForm } from '../../../components';
import { FORM_EDIT_PRODUCT } from './forms';
import { ResponsivePageLayout } from '../../../components/page/responsive-layout/ResponsivePageLayout';
import { ContainerButton } from '../../../styles/global-style';
import { useForm } from 'react-hook-form';
import { useGetEditProduct } from './hooks/useGetEditProduct';
import { columns } from './columns';
import { useGetManageData } from './hooks/useGetManageData';
import {
  categoryQuery,
  productGroupCodeQuery,
  productTypeQuery,
} from '../../../services/react-query/optionMasterQuery';
import { useManagementData } from './hooks/onGetOptions';
import { useUpdateManagement } from './hooks/useUpdateManagement';
import { handleSubmitForm } from './func/handleSubmitform';
import { useModal } from '../../../components/modal/hooks/useModal';
import { useState } from 'preact/hooks';
import { useDeleteManageData } from './hooks/useDeleteManageData';
import { AddManagement } from './modals/AddModal';
import { EditModal } from './modals/EditModal';

export const EditProduct = () => {
  const [dataEdit, setDataEdit] = useState(null);
  const { control, setValue, getValues, watch, reset, handleSubmit } = useForm();
  const { open: openAdd, onToggle: onToggleAdd } = useModal();
  const { open: openEdit, onToggle: onToggleEdit } = useModal();
  const params = new URLSearchParams(window.location.search);
  const mapProductId = params.get('code');
  const selectedBrandId = watch('mobileBrandId');
  const isSpecialWarrantyStatus = watch('specialWarrantyStatus');
  const { mutate: mutateUpload, isPending: isPendingUpload } = useUpdateManagement();
  const { mutate: mutateDelete, isPending: isPendingDelete } = useDeleteManageData();

  const { data: categoryList, isPending: loadingCategory } = categoryQuery();
  const { brandList, modelList, loadingBrand, loadingModel } = useManagementData(
    selectedBrandId || '',
  );
  const { data: productTypeList, isPending: loadingProductType } = productTypeQuery();
  const { data: productGroupCodeList, isPending: loadingProductGroupCode } =
    productGroupCodeQuery();

  const { loading: isLoadingEditProduct } = useGetEditProduct({
    mapProductId: mapProductId,
    reset,
  });

  const onEditSpecialWarranty = (record) => {
    setDataEdit(record);
    onToggleEdit({ defaultValues: record });
  };

  const { data: dataTable, isPending: loadingDataTable } = useGetManageData(mapProductId);
  const columnData = columns({ onEditSpecialWarranty, mutateDelete });

  const onSubmit = (value) => handleSubmitForm(value, mutateUpload);

  return (
    <Spin
      spinning={
        isLoadingEditProduct ||
        isPendingDelete ||
        loadingCategory ||
        loadingProductType ||
        loadingProductGroupCode ||
        loadingBrand ||
        loadingModel
      }
    >
      <StyledContainer>
        <Row gutter={16}>
          <Col span={12}>
            <CardTheme>
              <TextLarge text="แก้ไขจัดกลุ่มสินค้า " />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_EDIT_PRODUCT({
                  categoryList,
                  brandList,
                  modelList,
                  productTypeList,
                  productGroupCodeList,
                })}
              />
              <ContainerButton center>
                {isPendingUpload ? (
                  <Spin spinning={isPendingUpload}></Spin>
                ) : (
                  <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
                )}
              </ContainerButton>
            </CardTheme>
          </Col>
          {isSpecialWarrantyStatus === 'ACTIVE' && (
            <Col span={12}>
              <CardTheme>
                <TextLarge text="ช่องทางการรับประกันพิเศษ" />
                <ContainerButton right>
                  <ButtonTheme
                    useFor="WARRANTY"
                    title="เพิ่มช่องทางรับประกัน"
                    onClick={onToggleAdd}
                  />
                  {openAdd && (
                    <AddManagement
                      open={openAdd}
                      onToggle={onToggleAdd}
                      mapProductId={mapProductId}
                    />
                  )}
                </ContainerButton>
                <ResponsivePageLayout
                  tableLayout={{
                    columns: columnData,
                    dataSource: Array.isArray(dataTable) ? dataTable : [],
                  }}
                />
              </CardTheme>
              {openEdit && (
                <EditModal open={openEdit} onToggle={onToggleEdit} initailValues={dataEdit} />
              )}
            </Col>
          )}
        </Row>
      </StyledContainer>
    </Spin>
  );
};
